// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"678":"66b538efc939a7adb484","883":"041d3579e104b9c3fa99","989":"e5df52166fbfbbb55670"}[chunkId] + ".js";
};